import { FULL_SYLLABUS, INTENSITY_CONFIG } from '../constants';
import { Priority, StudyIntensity, StudyStrategy } from '../types';

// Algoritmo Fisher-Yates para embaralhamento imparcial
function shuffleArray(array) {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}

export const generateSchedule = (
  weeksAvailable, 
  intensity = StudyIntensity.MODERATE,
  strategy = StudyStrategy.PRIORITIZE_HIGH
) => {
  // 1. Flatten all topics with their metadata
  const allTopics = FULL_SYLLABUS.flatMap(category =>
    category.topics.map(topic => ({
      ...topic,
      category: category.categoryName,
      priority: category.priority,
      subject: category.subject,
      originalTopicId: topic.id
    }))
  );

  // 2. Shuffle ALL topics first. 
  const shuffledTopics = shuffleArray(allTopics);

  // 3. Sort by priority
  const priorityOrder = { [Priority.HIGH]: 0, [Priority.MEDIUM]: 1, [Priority.LOW]: 2 };
  
  const sortedTopics = shuffledTopics.sort((a, b) => {
    // Primary sort: Incidence Priority (High > Medium > Low)
    return priorityOrder[a.priority] - priorityOrder[b.priority];
  });

  // 4. Determine how many topics we can realistically cover
  const totalTopics = sortedTopics.length;
  let topicsToCover = sortedTopics;
  
  // Use intensity configuration to determine max topics per week
  const maxTopicsPerWeek = INTENSITY_CONFIG[intensity];
  
  if (strategy === StudyStrategy.PRIORITIZE_HIGH) {
    // If prioritizing high incidence, we respect the intensity limit and cut topics if needed
    const idealCapacity = weeksAvailable * maxTopicsPerWeek;
    if (idealCapacity < totalTopics) {
      topicsToCover = sortedTopics.slice(0, idealCapacity);
    }
  }
  // If strategy is COVER_ALL, we keep all topics and compress them into the available weeks

  // 5. Distribute into weeks
  const schedule = [];
  const topicsPerWeek = Math.ceil(topicsToCover.length / weeksAvailable);

  let currentTopicIndex = 0;

  for (let week = 1; week <= weeksAvailable; week++) {
    const weeklyTopics = [];
    
    // Fill the week
    for (let i = 0; i < topicsPerWeek; i++) {
      if (currentTopicIndex < topicsToCover.length) {
        weeklyTopics.push(topicsToCover[currentTopicIndex]);
        currentTopicIndex++;
      }
    }

    if (weeklyTopics.length > 0) {
      schedule.push({
        weekNumber: week,
        topics: weeklyTopics
      });
    }
  }

  return schedule;
};

export const calculateDaysRemaining = (examDateStr) => {
  const examDate = new Date(examDateStr);
  const today = new Date();
  const diffTime = Math.abs(examDate.getTime() - today.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
  return diffDays;
};

export const calculateWeeksRemaining = (examDateStr) => {
    const days = calculateDaysRemaining(examDateStr);
    return Math.max(1, Math.floor(days / 7));
};